if (!window.Eurus) window.Eurus = { loadedScript: [] };
if (!window.Eurus.loadedScript.includes('wobe-store-reviews.js')) {
  window.Eurus.loadedScript.push('wobe-store-reviews.js');

  (function () {
    var STAR_PATH =
      'M12 2.5l2.9 5.88 6.49.94-4.7 4.58 1.11 6.47L12 17.77l-5.8 3.05 1.11-6.47-4.7-4.58 6.49-.94L12 2.5z';

    function round1(n) {
      return Math.round(Number(n) * 10) / 10;
    }

    function starHtml(score) {
      var fill = Math.floor(score);
      var decimal = score - fill;
      var half = 0;
      if (decimal >= 0.3 && decimal <= 0.7) half = 1;
      else if (decimal > 0.7) fill += 1;
      if (fill > 5) {
        fill = 5;
        half = 0;
      }
      var empty = 5 - fill - half;
      var html = '';
      var i;
      for (i = 0; i < fill; i++) {
        html +=
          '<svg class="wobe-store-reviews__star" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill="#305FAB" d="' +
          STAR_PATH +
          '"/></svg>';
      }
      if (half) {
        html +=
          '<svg class="wobe-store-reviews__star" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><defs><linearGradient id="wobe-store-reviews-half" x1="0" x2="1" y1="0" y2="0"><stop offset="50%" stop-color="#305FAB"/><stop offset="50%" stop-color="#305FAB" stop-opacity="0.25"/></linearGradient></defs><path fill="url(#wobe-store-reviews-half)" d="' +
          STAR_PATH +
          '"/></svg>';
      }
      for (i = 0; i < empty; i++) {
        html +=
          '<svg class="wobe-store-reviews__star wobe-store-reviews__star--empty" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill="#305FAB" d="' +
          STAR_PATH +
          '"/></svg>';
      }
      return html;
    }

    function widgetMarkup(scoreRaw, count) {
      var score = round1(scoreRaw);
      return (
        '<div class="wobe-store-reviews">' +
        '<a class="wobe-store-reviews__link" href="javascript:void(0)" aria-label="' +
        score +
        ' out of 5 stars based on ' +
        count +
        ' reviews">' +
        '<span class="wobe-store-reviews__rating" data-wobe-rating-wrap data-score="' +
        scoreRaw +
        '">' +
        '<span class="wobe-store-reviews__score" data-wobe-score>' +
        score +
        '</span>' +
        '<span class="wobe-store-reviews__stars" data-wobe-stars aria-hidden="true">' +
        starHtml(Number(scoreRaw)) +
        '</span>' +
        '</span>' +
        '<span class="wobe-store-reviews__count" data-wobe-count data-number-of-reviews="' +
        count +
        '" data-score="' +
        scoreRaw +
        '">(' +
        count +
        ' Reviews)</span>' +
        '</a>' +
        '</div>'
      );
    }

    function readJudgeMeData() {
      // Prefer All Reviews page header — outside .main-product, survives sibling swaps
      var header = document.querySelector(
        '.jdgm-all-reviews__header[data-average-rating][data-number-of-reviews]'
      );
      if (header) {
        return {
          score: header.getAttribute('data-average-rating'),
          count: header.getAttribute('data-number-of-reviews'),
        };
      }

      return window.__wobeStoreReviews || null;
    }

    function applyTo(root, data) {
      if (!root || !data || data.score == null || data.count == null) return false;

      // Always rebuild markup so Judge.me branded widgets cannot stick
      root.innerHTML = widgetMarkup(data.score, data.count);

      window.__wobeStoreReviews = {
        score: data.score,
        count: data.count,
        html: root.outerHTML,
      };
      return true;
    }

    function restoreMissing(html) {
      if (document.querySelector('[data-wobe-store-reviews]')) return;
      var info = document.querySelector(
        '.main-product .product-info, .main-product [id^="ProductInfo-"]'
      );
      if (!info) return;
      var wrapper = document.createElement('div');
      wrapper.className = 'custom-html mb-4 md:mb-6 w-full';
      wrapper.innerHTML = html;
      info.insertBefore(wrapper, info.firstElementChild);
    }

    function hydrateAll() {
      var data = readJudgeMeData();
      var roots = document.querySelectorAll('[data-wobe-store-reviews]');

      if (!roots.length) {
        if (window.__wobeStoreReviews && window.__wobeStoreReviews.html) {
          restoreMissing(window.__wobeStoreReviews.html);
          roots = document.querySelectorAll('[data-wobe-store-reviews]');
        }
      }

      roots.forEach(function (root) {
        applyTo(root, data);
      });
    }

    function isCorrupted(root) {
      if (!root) return false;
      return (
        !!root.querySelector('.jdgm-verified-by, .jdgm-star, [data-widget-name="all_reviews_text"]') ||
        !!root.querySelector('.jdgm-all-reviews-text--style-branded') ||
        (root.querySelector('[data-wobe-count]') &&
          root.querySelector('[data-wobe-count]').textContent.indexOf('out of 5') !== -1)
      );
    }

    function init() {
      hydrateAll();

      var tries = 0;
      var timer = setInterval(function () {
        tries += 1;
        hydrateAll();
        if ((window.__wobeStoreReviews && window.__wobeStoreReviews.count) || tries > 40) {
          clearInterval(timer);
        }
      }, 250);

      document.addEventListener('wobe:product-sibling-swapped', function () {
        setTimeout(hydrateAll, 0);
        setTimeout(hydrateAll, 100);
      });

      if (!window.__wobeStoreReviewsObserver) {
        var main = document.querySelector('.main-product');
        if (main) {
          window.__wobeStoreReviewsObserver = new MutationObserver(function () {
            setTimeout(function () {
              document.querySelectorAll('[data-wobe-store-reviews]').forEach(function (root) {
                if (isCorrupted(root) || !root.querySelector('[data-wobe-score]')) {
                  hydrateAll();
                }
              });
              if (!document.querySelector('[data-wobe-store-reviews]')) {
                hydrateAll();
              }
            }, 0);
          });
          window.__wobeStoreReviewsObserver.observe(main, {
            childList: true,
            subtree: true,
          });
        }
      }

      // Scroll to store reviews section (replaces old .jdgm-all-reviews-text click)
      document.addEventListener(
        'click',
        function (e) {
          var trigger = e.target.closest('[data-wobe-store-reviews], .wobe-store-reviews');
          if (!trigger) return;
          var reviews =
            document.querySelector('.jm-review-widget__header-and-body') ||
            document.querySelector('.jdgm-all-reviews-widget-v2025') ||
            document.querySelector('.jdgm-all-reviews__header');
          if (!reviews) return;
          e.preventDefault();
          e.stopPropagation();
          var top = reviews.getBoundingClientRect().top + window.scrollY - 100;
          window.scrollTo({ top: top, behavior: 'smooth' });
        },
        true
      );
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
}
